/** 渠道类型 */
export enum EChannel {
  /** 来源渠道 */
  Source,
  /** 广告位 */
  Advertising
}

/** 描述数据 */
export const MChannel = {
  [EChannel.Source]: '来源渠道',
  [EChannel.Advertising]: '广告位'
}

export const TaskType = {
  1: '晒单',
  2: '加圈子',
  3: '发帖',
  4: '调查问卷',
  5: '邀请进圈',
  6: '邀请注册',
  8: '关注公众号',
  9: '商品打卡',
  13: '发视频'
}
export enum ActiviteType {
  '抽奖' = 0,
  '大转盘' = 1
}
export enum LotteryResult {
  '未中奖' = false,
  '中奖' = true
}
export enum PrizeType {
  '谢谢参与' = 0,
  '实物' = 1,
  '积分' = 2
}
export enum DeliveryStatus {
  'WAIT_SHIPPED' = '待发货',
  'SHIPPED' = '已发货',
  'COMPLETED' = '已完成',
  'VOIDED' = '已作废'
}
export enum ChangeType {
  '晒单' = 1,
  '加入圈子' = 2,
  '发帖' = 3,
  '调研' = 4,
  '邀请进圈' = 5,
  '邀请注册' = 6,
  '签到' = 7,
  '兑换商品' = 8,
  '订单作废' = 9,
  '参与大转盘' = 10,
  '参与大转盘.' = 11,
  '完善资料' = 12,
  '发视频' = 13,
  '精华帖' = 14,
  '订单验证' = 15,
  '悬赏贴发布失败返还' = 16,
  '参与悬赏贴' = 17,
  '发悬赏贴' = 18,
  '新用户奖励' = 19,
  '反馈奖励' = 20,
  '关注公众号' = 21,
  '商品打卡' = 22,
  '战队活动个人PK' = 23,
  '战队活动PK平分' = 24,
  '周月榜个人PK' = 25,
  '周月榜战队平分' = 26,
  '战队邀请' = 27,
  '每日任务' = 28,
  '补签' = 29,
  '盲盒活动' = 30,
  '系统赠送' = 98,
  '系统发放' = 99
}
export enum AuditStatus {
  '待审核' = 0,
  '已审核' = 1,
  '不需要审核' = 2,
  '已驳回' = -1
}
export enum AuditStatu {
  '待审核' = 0,
  '处理中' = 1,
  '已处理' = 2
}
export enum GaiaStatus {
  '未推送' = 0,
  '已推送' = 1,
  '已审核' = 2
}
export enum ProblemType {
  '商品问题' = 1,
  '物流问题' = 2,
  '其他问题' = 3
}
export enum PushIs {
  '已推送' = true,
  '未推送' = false
}

export enum EmShipStatus {
  /**已发货 */
  '已发货',
  /** 代发货 */
  '待发货'
}
export enum BuyPlatform {
  '快手' = 0,
  '淘宝' = 1,
  '拼多多 ' = 2,
  '京东' = 3,
  '其他' = 4
}
export enum GiftType {
  '提货卡' = 1,
  '礼品卡' = 2
}
